import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Row, Col, Container } from 'react-bootstrap'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'

class Kvm extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 200px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 1350px 0 50px 0;
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 100px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 50px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
        `

        const ServiceHeadinga = styled.a`
            font-family: Oswald;
            color: #84a841;
            transition: .5s;
            &:hover {
              color: #1a1a1a;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #84a841;
            margin-bottom: 5px;
        `

        const ServiceLinea = styled.div`
            height: 1px;
            width: 200px;
            background-color: #808080;
            margin: 2px 0 7px 0;
         `

        const ServiceNumber = styled.p`
            position: absolute;
            font-size: 30px;
            color: #717171;
            font-weight: 900;
            top: -50px;
            opacity: .1;
            z-index: -1;
            transition: .2s;
         `

        const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #65ff00;
            }
        `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #808080;
            padding-right: 25px;            
        `

        const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #000000;
            padding-right: 25px;            
        `

        const Submit = styled.a`
            background-color: #fff !important;
            color: #4b7d2f !important;
            border: solid 1px #4b7d2f;
            cursor: pointer !important;
            border-radius: 3px;
            font-size: 14px;
            line-height: 1;
            margin: 0;
            padding: 17px 26px;
            position: relative;
            letter-spacing: 0.02em;
            font-family: "Open Sans Semibold";
            box-shadow: 0 2px 8px 0 rgba(62, 62, 79, .23);
	        -webkit-transition: all 300ms linear 0ms;
	        -moz-transition: all 300ms linear 0ms;
	        -ms-transition: all 300ms linear 0ms;
            transition: all 300ms linear 0ms;
            display: inline-block;
            font-weight: 400;            
            text-transform: uppercase;          
            &:hover {              
                transform: translateX(-20%);
                text-decoration: none;
                background-color: #c1eb18 !important;
	            color: #000 !important;
	            border: none;
                box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .30);
	            -webkit-transform: translateY(-5px);
	            transform: translateY(-5px);              
            }            
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #6c6c6c;            
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 20px;
        `
        const Heading2 = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            color: #1a1a1a;
            line-height: 70px;
            font-weight: 800;
            text-align: center;
            padding-bottom: 80px;            
        `
        const Heading2b = styled.h2`
            font-size: 50px;
            font-family: "Montserrat", sans-serif;
            color: #1a1a1a;
            line-height: 60px;
            font-weight: 800;
            text-align: center;
            padding-bottom: 80px;
            @media (min-width:768px) and (max-width:1500px) {                
                padding-top: 200px;
            }
                @media (max-width: 767px) {
                font-size: 40px;
                line-height: 50px;           
            }
        `
        const Heading3 = styled.h3`
            font-size: 50px;
            font-family: Poppins;
            color: #84a841;
            line-height: 50px;
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #808080;
            padding-bottom: 30px;
        `

        const Text6 = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #808080;            
            margin: 30px;
            padding-top: 50px;
        `

        const ImageCol = styled(Col)`
            margin: 30px;
            padding-bottom: 30px;
            align-items: center;
            justify-content: center;
            @media (max-width: 767px) {
              .image-col {
                  text-align: center;
              }
            }
            transition: .2s;
            &:hover {                
                transform: translateY(-10px);
            }
        `
        const ColorV = styled.span`            
        font-weight: bold;
        color: #c1eb18;            
        `

        const { data } = this.props;
        console.log(data)
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }

        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return (
            <Section>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Heading2b>Servidores VPS Linux Powered by KV<ColorV>M</ColorV></Heading2b>
                            <Separator />
                            <Text>La tecnología KVM opera a nivel de kernel, lo que permite la virtualización completa de recursos, como CPU, RAM y almacenamiento.
                                Esta capacidad proporciona a los usuarios una experiencia similar a la de un servidor dedicado.
                            </Text>
                            <Text>La ventaja más destacada de los servidores VPS KVM es su aislamiento completo. Cada máquina virtual opera de manera independiente,
                                lo que significa que los recursos asignados son exclusivos y no se comparten entre diferentes usuarios.
                            </Text>
                        </Col>
                    </Row>
                </Container>
                <Container>
                    <Row>
                        <Col md={12}>
                            <Heading2>VPS KVM Colombia</Heading2>
                            <Separator />
                            <Heading3>VPS SSD No Administrado Powered by KVM</Heading3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>

                            <Text6>
                                Los servidores VPS (Servidores Privados Virtuales) con discos SSD, basados en la tecnología KVM (Kernel-based Virtual Machine) representan una solución líder
                                en el ámbito de la infraestructura virtualizada. Con un enfoque altamente eficiente y una seguridad sólida.
                            </Text6>

                        </Col>
                        <Col md={6}>

                            <ImageCol>
                                <GatsbyImage image={this.props.image} alt="VPS KVM SSD" />
                            </ImageCol>

                        </Col>
                    </Row>

                    <ServiceRow>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=202" target="_self">
                                        VPS KVM SSD1
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <Color>2Gb.</Color> RAM
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>20</Color> Gb SSD de espacio
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>2 CPU Cores 100% </Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>1 Tb.</Color> de Ancho de banda
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    1 dirección IP
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    CentOS 7, Debian 9, Debian 10, Ubuntu 18.04 o Ubuntu 20.04
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'kvmssd 1').price}/mes
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=202">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=203">
                                        VPS KVM SSD2
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <Color>4Gb.</Color> RAM
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>40</Color> Gb SSD de espacio
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>2 CPU Cores 100% </Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>1 Tb.</Color> de Ancho de banda
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    2 direcciones IP
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    CentOS 7, Debian 9, Debian 10, Ubuntu 18.04 o Ubuntu 20.04
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'kvmssd 2').price}/mes
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=203">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=204">
                                        VPS KVM SSD3
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <Color>6Gb.</Color> RAM
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>80</Color> Gb SSD de espacio
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>3 CPU Cores 100% </Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>2 Tb.</Color> de Ancho de banda
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    2 direcciones IP
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    CentOS 7, Debian 9, Debian 10, Ubuntu 18.04 o Ubuntu 20.04
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'kvmssd 3').price}/mes
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=204">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                        <Col md={3}>

                            <ServiceElement>
                                <ServiceHeading>
                                    <ServiceHeadinga href="https://vascosolutions.com/zc/cart.php?a=add&pid=205">
                                        VPS KVM SSD4
                                    </ServiceHeadinga>
                                </ServiceHeading>
                                <ServiceSeparator />
                                <ServiceText>
                                    <Color>8Gb.</Color> RAM
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>120</Color> Gb SSD de espacio
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>4 CPU Cores 100% </Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    <Color>2 Tb.</Color> de Ancho de banda
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    2 direcciones IP
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    CentOS 7, Debian 9, Debian 10, Ubuntu 18.04 o Ubuntu 20.04
                                </ServiceText>
                                <ServiceLinea />
                                <ServiceText>
                                    Garantía de devolución <Color>30 días</Color>
                                </ServiceText>
                                <ServiceLinea />
                                <ServicePrecio>
                                    ${prices.find(x => x.name === 'kvmssd 4').price}/mes
                                </ServicePrecio>
                                <Submit href="https://vascosolutions.com/zc/cart.php?a=add&pid=205">
                                    <span>
                                        Contratar
                                    </span>
                                </Submit>
                            </ServiceElement>

                        </Col>
                    </ServiceRow>
                </Container>
            </Section>
        )
    }

}

const PrecioImagen = (props) => (
    <StaticQuery
      query={graphql`
        query {
          allPricesJson(filter: { page: { eq: "kvm" }, section: { eq: "planes" } }) {
            nodes {
              items {
                name
                price
              }
            }
          }
          file(relativePath: {eq: "ssd.jpg"}) {
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                placeholder: DOMINANT_COLOR
                quality: 80
                formats: [AUTO, WEBP, AVIF]
                width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return (
          <Kvm
            data={data}
            image={image}
            {...props}
          />
        );
      }}
    />
  );
  
  export default PrecioImagen;
